/** @format */

export const APP_VERSION = '0.1.0';

export const ONBOARDING_PAGE_ID = 234;
export const HELP_DASHBOARD_ID = 75;

export const ENABLE_REDUX_DEV_TOOLS = true;

export interface NewsletterTopicTab {
  id: string;
  label: string;
}

export const DEFAULT_NEWSLETTER_TOPIC_TABS: NewsletterTopicTab[] = [
  { id: 'all', label: 'All Topics' },
  { id: 'ate', label: 'ATE Topics' },
  { id: 'vdo', label: 'VDO Topics' }
];

export const THEMES = {
  AUMOVIO_AFM: 'AUMOVIO_AFM'
} as const;

export const ENDPOINTS = {
  // User
  GET_USER_ENDPOINT: '/api/user',
  GET_USER_INFO_ENDPOINT: '/api/user/info',
  // Onboarding
  ONBOARDING_COMPLETE_ENDPOINT: '/api/v1/users',

  //Widget
  GET_WIDGET_ENDPOINT: 'api/widgets/dashboard',
  GET_PUBLIC_CONTENT_INFO_ENDPOINT: 'api/public/content',
  GET_PRIVATE_CONTENT_INFO_ENDPOINT: 'api/content',
  GET_DASHBOARD_ENDPOINT: 'api/widgets/sub-dashboard/',

  // Footer
  GET_FOOTER_LINKS_ENDPOINTS: 'api/public/footer/links',

  // Dashboard Config
  SET_DASHBOARD_LAYOUT: 'api/dashboards/config',

  // Download tracking
  TRACK_DOWNLOAD_ENDOIUNT: 'api/v1/tracking/track',
  TRACK_DOWNLOAD_ENDPOINT: 'api/v1/tracking/track',

  // Knowledge Base
  GET_KNOWLEDGE_BASE_ENDOIUNT: 'api/v1/kb',
  GET_KNOWLEDGE_BASE_CATEGORIES_ENDOIUNT: 'api/v1/kb/categories',
  GET_KNOWLEDGE_BASE_VOTE_ENDOIUNT: 'api/v1/kb/vote',

  // News
  GET_NEWS_ENDPOINT: 'api/v1/news',
  GET_NEWS_CATEGORIES_ENDPOINT: 'api/v1/news/categories',
  GET_NEWS_VOTE_ENDPOINT: 'api/v1/news/vote',

  // Events
  GET_EVENTS_ENDPOINT: 'api/v1/events',
  GET_EVENTS_CATEGORIES_ENDPOINT: 'api/v1/events/categories',
  GET_EVENTS_VOTE_ENDPOINT: 'api/v1/events/vote',

  // Topics (list / tree; supports cursor pagination) → /api/v1/topics
  GET_TOPICS_ENDPOINT: 'api/v1/topics',

  // Tags
  GET_TAGS_ENDPOINT: 'api/v1/tags',
  SEARCH_TAGS_ENDPOINT: 'api/v1/tags/search',

  // Search
  SEARCH_ENDPOINT: 'api/v1/search',

  // Content
  GET_CONTENT_POST_ENDPOINT: 'api/v1/content-posts',
  GET_CONTENTS_ENDPOINT: 'api/v1/content-list',
  GET_EDITORS_ENDPOINT: 'api/v1/editors',

  // Academy
  GET_EVENTS_TRAININGS_ENDPOINT: 'api/v1/academy/trainings',
  GET_EVENTS_BOOKINGS_ENDPOINT: 'api/v1/academy/bookings',

  // Shop
  GET_SHOP_ORDERS_ENDPOINT: 'api/v1/shop/orders'
} as const;

export const ACTION_CONSTANTS = {
  /**
   * User
   */
  USER_LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
  USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
  USER_LOGIN_FAIL: 'USER_LOGIN_FAIL',
  USER_UPDATE_REQUEST: 'USER_UPDATE_REQUEST',
  USER_UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
  USER_UPDATE_FAIL: 'USER_UPDATE_FAIL',

  USER_UPDATE_DATA: 'USER_UPDATE_DATA',

  ON_BOARDING_COMPLETE: 'ON_BOARDING_COMPLETE'
} as const;

export const VALIDATE_REGEX = {
  email: /[a-zA-Z0-9._]*@[a-zA-Z0-9.-]*\.[a-z]*/,
  phone: /^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/im,
  password:
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!,;`~'":{}<>^/@#$%^&*?|\\[\]\\)(+=._-])([a-zA-Z0-9!,;`~'":{}<>^/@#$%^&*?|\\[\]\\)(+=._-]){8,30}$/
};

export const API_URL: string | undefined = process.env.REACT_APP_API_URL;
export const IS_PRODUCTION = process.env.REACT_APP_IS_PRODUCTION == 'true';

export const SHOP_ORDERS_HISTORY_URL = IS_PRODUCTION
  ? 'https://shop.ate.de/ate_en/sales/order/history/'
  : 'https://mcstaging.shop.ate.de/ate_en/sales/order/history/';

export const NO_IMAGE_BASE64 = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export const ADMINISTRATION_FUNCTIONS = {
  TOPICS: true,
  TAGS: false
} as const;

export interface ContentLanguageOption {
  title: string;
  value: string;
  market: string;
}

export const CONTENT_LANGUAGES: ContentLanguageOption[] = [
  {
    title: 'English',
    value: 'en',
    market: 'International'
  },
  {
    title: 'Français',
    value: 'fr',
    market: 'France'
  },
  {
    title: 'Deutsch',
    value: 'de',
    market: 'Deutschland'
  },
  {
    title: 'Español',
    value: 'es',
    market: 'España'
  },
  {
    title: 'Italiano',
    value: 'it',
    market: 'Italia'
  },
  {
    title: 'Polish',
    value: 'pl',
    market: 'Poland'
  },
  {
    title: 'Deutsch',
    value: 'de-AT',
    market: 'Österreich'
  },
  {
    title: 'English',
    value: 'en-GB',
    market: 'United Kingdom'
  },
  {
    title: 'Czech',
    value: 'cs',
    market: 'Czech Republic'
  },
  {
    title: 'Deutsch',
    value: 'de-CH',
    market: 'Schweiz'
  }
];

export interface SortOption {
  key: string;
  value: string;
  translationKey: string;
}

export const TOPIC_SORT_OPTIONS: SortOption[] = [
  { key: 'relevant', value: 'relevant', translationKey: 'common.sort.relevant' },
  { key: 'latest', value: 'latest', translationKey: 'common.sort.latest' },
  { key: 'title', value: 'title', translationKey: 'common.sort.title' },
  { key: 'created', value: 'created', translationKey: 'common.sort.created' },
  { key: 'language', value: 'language', translationKey: 'common.sort.language' }
];

export const SEARCH_SORT_OPTIONS: SortOption[] = [
  { key: 'latest', value: 'latest', translationKey: 'common.sort.latest' },
  { key: 'relevant', value: 'relevant', translationKey: 'common.sort.relevant' }
];

export const EDITOR_BLOCK_ENABLE_MOVE_BUTTONS = false;

// Temporarily hidden: the customer is not using content translations yet.
export const SHOW_CONTENT_LANGUAGE_SWITCH = false;

// Content Editor
export const DOCUMENT_MAX_FILES = 6;

// Roles
export const ROLES = {
  ADMIN: 'Extranet Admin',
  CONTENT_EDITOR: 'Extranet Content Editor'
} as const;
